import { render, staticRenderFns } from "./AppCubeTag.vue?vue&type=template&id=77ec02ff"
import script from "./AppCubeTag.vue?vue&type=script&lang=js"
export * from "./AppCubeTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports